import { ContentSectionBase } from '@liswood-tache/browsbox-static';
import ContentSectionGallery from './ContentSectionGallery';
import ContentSectionSlider from './ContentSectionSlider';

const ContentSections = {
  base: ContentSectionBase,
  gallery: ContentSectionGallery,
  slider: ContentSectionSlider,
};

export default ContentSections;
